import { inject, Injectable } from '@angular/core';
import { ClearAuthState } from '@app/infrastructure/authentication/auth.actions';
import { AUTH_STATE_NAME, AuthState } from '@app/infrastructure/authentication/auth.state';
import { Store } from '@ngxs/store';
import { filter, fromEvent } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CrossTabLogoutService {
  private readonly store = inject(Store);

  init(): void {
    fromEvent<StorageEvent>(window, 'storage')
      .pipe(filter((event) => event.key === AUTH_STATE_NAME))
      .subscribe((event) => {
        if (!event.newValue) return;
        const newState = JSON.parse(event.newValue);
        if (!newState.tokens && this.store.selectSnapshot(AuthState.isAuthenticated)) {
          this.store.dispatch(new ClearAuthState());
        }
      });
  }
}
